import React from 'react';
import styles from './InsufficientBalance.module.css'; // Assuming you have a CSS module for styling
import { parseDecimalValuesOfNumber } from '@/Common/utils/GameUtils';
import usePlatformCommunication from '@/src/hooks/utils/usePlatformCommunication';
import { RUPEE_SYMBOL } from '@/Poker/data/Constants';
import { DrawerClose, DrawerHeader } from '../ui/drawer';
import { IoCloseSharp } from 'react-icons/io5';
import { useDispatch } from 'react-redux';
import { hideInsufficientBalance } from '@/Poker/redux/slices/gameTableSlice';

export default function InsufficientBalance({ handleCloseMark, totalBalance, minBuyInAmount, tempTableId }) {
    const { addCashNavigation } = usePlatformCommunication();
    const dispatch = useDispatch();

    // const closeDrawer = () => {
    //     if (tempTableId) {
    //         dispatch(hideInsufficientBalance({ tempTableId }));
    //     }
    // }

    return (
        <div className={styles.insufficientBalanceContainer}>
            <DrawerHeader className={styles.drawerHeader}>
                <h2 className={styles.title}>Insufficient Balance</h2>
                <DrawerClose onClick={handleCloseMark} className={styles.closeButton}>
                    <IoCloseSharp size={24} className={styles.closeIcon} />
                </DrawerClose>
            </DrawerHeader>
            <div className={styles.messageContainer}>
                <div className={styles.balanceInfo}>
                    <span className={styles.balanceLabel}>Total Balance:</span>
                    <span className={styles.balanceValue}>{RUPEE_SYMBOL + parseDecimalValuesOfNumber(totalBalance, 2)}</span>
                </div>
                <div className={styles.balanceInfo}>
                    <span className={styles.balanceLabel}>Min Buy In:</span>
                    <span className={styles.balanceValue}>{RUPEE_SYMBOL + parseDecimalValuesOfNumber(minBuyInAmount, 2)}</span>
                </div>
                <div className={styles.balanceInfo}>
                    <span className={styles.balanceLabel}>Amount to add:</span>
                    <span className={styles.balanceValue}>{RUPEE_SYMBOL + parseDecimalValuesOfNumber(minBuyInAmount - totalBalance, 2)}</span>
                </div>
            </div>
            <div className={styles.buttonContainer}>
                <div className={styles.addCashButton} onClick={addCashNavigation}>
                    Add Cash
                </div>
            </div>
        </div>
    );
}
